import { PurchaseOrderStatus } from '../models/purchase-order/purchase-order-status.model';

export const PurchaseOrderStatusValues = [
  'WAITING_CONFIRMATION',
  'IN_SEPARATION',
  'AWAITING_COLLECTION',
  'DISPATCHED',
  'REFUSED',
  'CANCELED',
  'DELIVERED',
] as PurchaseOrderStatus[];
